<template>
  <el-main>
    <div class="main">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          style="min-height: 100%"
        ></router-view>
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        style="min-height: 100%"
      ></router-view>
    </div>
  </el-main>
</template>
<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      index: 0,
      loading: false,
    };
  },
  computed: {
    tags() {
      return this.$store.state.routerTags;
    },
    routerIndex() {
      return this.$store.state.routerIndex;
    },
  },
  methods: {
    // 切换tags路由
    cutRouter(i, router) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);

      this.index = i;
      if (!router) {
        return;
      }
      this.$store.dispatch("setRouterActive", router);
      this.$router.push({
        path: router,
      });
    },
    // 删除tsgs 路由
    remove(i) {
      this.$store.dispatch("removeRouterTag", i);
      let routerTag = this.$store.state.routerTags;
      this.cutRouter(routerTag.length, routerTag[routerTag.length - 1].router);
    },
  },
  watch: {
    routerIndex(i) {
      i--;
      this.cutRouter(i, "");
    },
  },
};
</script>

<style lang="scss">
.el-main {
  height: 100%;
  overflow: hidden !important;
  padding: 0 !important;
  position: relative;
  .main {
    width: calc(100% - 40px);
    height: calc(100% - 20px);
    background: white;
    overflow-y: auto !important;
    padding: 60px 20px 20px 20px !important;
    position: relative;
    margin: 10px 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
}
</style>
